import style from './Start-Page.module.scss'
import logo from '../../../assets/imgs/logo/el_gran_kush/lg_wht_png.png'
import { Navigate, NavLink } from 'react-router-dom'
import { Route, Routes } from "react-router-dom"
import LoginPage from '../Login-Page/Login-Page'
import RegistrationPage from '../Login-Page/Registration-Page'
import Button from '../Elements/Button/Button'
import PreAppPage from '../Pages/PreAppPage'
import Contacts from '../Main/Contacts/Contacts'


const Start = () => {


    return (

       

        <div className={style.start}>
            <div className={style.slogan__wrapper}>

                <p className={style.slogan__text}>No somos sólo un club, somos comunidad…</p>
                {/* <h1 className={style.slogan__title}>El Gran Kush</h1> */}
            </div>

            <div className={style.buttons__wrapper}>

                <div className={style.button__wrapper}>
                    <NavLink className={style.button__link} to='../login'>
                        <Button color={'red'} border={12} name={'Login'} />
                    </NavLink>
                </div>
                <div className={style.button__wrapper}>
                    <NavLink className={style.button__link} to='../registration'>
                        <Button color={'white'} border={12} name={'Registaration'} />
                    </NavLink>

                </div>
            </div>
        </div>


    )
}
const StartPage = (user) => {

    return (
        <>
            <Routes>
                <Route path="/" element={<PreAppPage isStart={true}><Start /></PreAppPage>} />
                <Route path="*" index element={<PreAppPage isStart={true}><Start /></PreAppPage>} />
                <Route path="start" element={<PreAppPage  isStart={true}><Start /></PreAppPage>} />
                <Route path="login" element={<LoginPage />} />
                <Route path="registration" element={<RegistrationPage />} />
                <Route path="profile" element={<Navigate replace to='../' />} />
                <Route path="contacts" element={<PreAppPage><Contacts /></PreAppPage>} />
            </Routes>

        </>

    )
}

export default StartPage